import { api, formatApiError } from "@/lib/api";
import { useState } from "react";
import SEO from "@/components/SEO";

export default function ForgotPassword() {
    const [step,setStep]=useState(1);
    const [email,setEmail]=useState("");
    const [token,setToken]=useState("");
    const [password,setPassword]=useState("");
    const [loading,setLoading]=useState(false);
    const [message,setMessage]=useState("");

    async function handleForgot(e){
        e.preventDefault();
        setLoading(true);
        setMessage("");
        try{
            const { data }= await api.post("/auth/forgot-password",{email});

            if(data.reset_token){
                setToken(data.reset_token);
                setStep(2);
                setMessage("Reset token generated");
            } else{
                setMessage("If account exists, reset request sent");
            }
        } catch(err){
            setMessage(formatApiError(err));
        }
        finally{
            setLoading(false);
        }
    }

    async function handleReset(e){
        e.preventDefault();
        setLoading(true);
        setMessage("");
        try{
            await api.post("/auth/reset-password",{
                    token,
                    password
                }
            );

            setStep(3);
            setMessage("Password changed successfully");
        } catch(err){
            setMessage(formatApiError(err));
        }
        finally{setLoading(false);}
    }

    return(
        <>
            <SEO title="Forgot Password" description="Reset your password - Self Preparation BD" />
            <div className="min-h-screen bg-hero-grad flex items-center justify-center px-4">
            <div className="glass shadow-pop rounded-3xl p-8 w-full max-w-md">
                <h1 className="text-3xl font-bold gradient-text-blue mb-2">
                    Forgot Password
                </h1>
                <p className="text-slate-500 mb-6">
                    Reset your password
                </p>
                {message &&
                    <div className="mb-4 p-3 rounded-xl bg-slate-100 text-sm">
                        {message}
                    </div>
                }
                {step===1 &&
                    <form onSubmit={handleForgot} className="space-y-4">
                        <input
                            type="email"
                            required
                            value={email}
                            placeholder="Email Address"
                            onChange={(e)=>
                                setEmail(e.target.value)
                            }
                            className="w-full rounded-xl border p-3 outline-none focus:ring-2 focus:ring-blue-800"
                        />
                        <button
                            disabled={loading}
                            className="btn-primary w-full py-3 rounded-xl"
                        >
                            {loading ? "Sending..." : "Send Reset"}
                        </button>
                    </form>
                }
                {step===2 &&
                    <form
                        onSubmit={handleReset}
                        className="space-y-4"
                    >
                        <input
                            hidden
                            value={token}
                            onChange={(e)=>
                                setToken(e.target.value)
                            }
                            placeholder="Reset Token"
                            className="w-full border rounded-xl p-3"
                        />
                        <input
                            type="password"
                            required
                            value={password}
                            placeholder="New Password"
                            onChange={(e)=>
                                setPassword(e.target.value)
                            }
                            className="w-full border rounded-xl p-3"
                        />
                        <button
                            disabled={loading}
                            className="btn-primary rounded-xl py-3 w-full"
                        >
                            {loading ? "Resetting..." : "Reset Password"}
                        </button>
                    </form>

                }
                {step===3 &&
                    <div className="text-center">
                        <p className="mt-3">
                            Password updated successfully
                        </p>
                    </div>
                }
            </div>
        </div>
        </>
    );
}
